<template lang="pug">
v-app
  v-content
    //- router-view
    //- router-view(v-if="routeNamesNotNeedFullUpdate.includes($route.name)")
    //- router-view(v-else :key="$route.fullPath")
    router-view(v-if="routeNamesNeedFullUpdate.includes($route.name)"
      :key="$route.fullPath")
    router-view(v-else)
    NavigationMessage
    Confirm
</template>

<script>
import NavigationMessage from '@/components/shared/NavigationMessage'
import Confirm from '@/components/shared/Confirm'

export default {
  name: 'App',
  components: {
    NavigationMessage, Confirm
  },
  data () {
    return {
      // routeNamesNotNeedFullUpdate: ['edit-page', 'top', 'user'],
      // routeNamesNeedFullUpdate: ['post']
      routeNamesNeedFullUpdate: []
    }
  },
  mounted () {
    this.appHeight()
    window.addEventListener('resize', this.appHeight)
  },
  destroyed () {
    window.removeEventListener('resize', this.appHeight)
  },
  methods: {
    appHeight () {
      const doc = document.documentElement
      doc.style.setProperty('--vh', (window.innerHeight*.01) + 'px')
    }
  }
}
</script>

<style lang="scss">
@import "./plugins/meltline.css";
@import "@/scss/_variables.scss";
@import "@/scss/common.scss";

// tourguid.jsのカスタマイズ
.tg-dialog {
  .tg-dialog-header {
    padding: 12px 15px 0 0px !important;
  }
  .tg-dot-active {
    background: $active_color !important;
  }
}
</style>
